import React from 'react'
import Layout from './Layout'
import {
  StateMachineProvider,
  createStore,
  setStorageType,
} from 'little-state-machine'
import { ID } from '../../types/id'
import { InquiryFormType } from '../../utils/constants'
import { Question } from './Question'
import { useQuery } from 'react-query'
import { useWithAuth } from '../../containers/App'
import { InquiryResponseModel, FormValues } from './types'
import { SpeLevel } from '../../utils/constants'
import { initialState } from '../../utils/initialState'

export type Store = {
  inquery: {
    answers: Record<number, string>
    activeIndex: number
    contrast: boolean
    fontSize: boolean
    defaultValues: FormValues
  }
}

type Props = {
  id: ID
  code: string
  speLevel: SpeLevel
  isDiagnostician?: boolean
  isEdition?: boolean
  examinationId?: ID
  formType: InquiryFormType['name']
}

const endpoint = '/form/rest/inquiry/response'

setStorageType({
  setItem: () => {},
  getItem: () => {
    return initialState
  },
  ...(typeof window !== 'undefined' && { ...localStorage }),
})
createStore(initialState)

function Scale({
  id,
  code,
  speLevel,
  isDiagnostician = false,
  isEdition = false,
  examinationId = null,
  formType,
}: Props) {
  const withAuth = useWithAuth()

  const { data } = useQuery<InquiryResponseModel | undefined, string>(
    `inquiry-${id}`,
    () =>
      withAuth(
        `${endpoint}/${id}`,
        {
          method: 'GET',
        },
        true
      ),
    {
      retry: false,
      refetchOnWindowFocus: false,
      manual: !isDiagnostician,
    }
  )

  return (
    <StateMachineProvider>
      <Layout
        type={formType}
        isDiagnostician={isDiagnostician}
        code={code}
        speLevel={speLevel}
        language={data?.model.lang}
      >
        <Question
          initialData={data?.model}
          formType={formType}
          scaleId={id}
          code={code}
          speLevel={speLevel}
          isDiagnostician={isDiagnostician}
          isEdition={isEdition}
          examinationId={examinationId}
        />
      </Layout>
    </StateMachineProvider>
  )
}

export default Scale
